import React from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import {
  BooleanInput,
  NumberInput,
  CurrencyInput,
  ItemCategorySelect,
  GLMainAccountSelect
} from "../inputs";
import { useAuthorization } from "../Authorization";

const ItemForm = ({ inputs, onChange, CompanySettings, codeStates }) => {
  const isAdminOrFinance = useAuthorization(["ADMIN", "FIN"]);
  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field kind="group">
            <Control expanded>
              <Label>Number</Label>
              <Input
                required
                autocomplete="new"
                name="ItemNo"
                type="text"
                value={inputs.ItemNo}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Description</Label>
              <Input
                required
                autocomplete="new"
                name="Description"
                type="text"
                value={inputs.Description}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Active</Label>
              <BooleanInput
                name="Active"
                value={inputs.Active}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Allow Discounts</Label>
              <BooleanInput
                name="AllowDiscounts"
                value={inputs.AllowDiscounts}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>Item Category</Label>
              <ItemCategorySelect
                required
                autocomplete="new"
                name="ItemCatgRecIdRef"
                type="text"
                value={inputs.ItemCatgRecIdRef}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Min Qty</Label>
              <NumberInput
                name="MinQty"
                type="number"
                value={inputs.MinQty}
                onChange={onChange}
              />
            </Control>
            <Control expanded>
              <Label>Max Qty</Label>
              <NumberInput
                name="MaxQty"
                type="number"
                value={inputs.MaxQty}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            {CompanySettings &&
              CompanySettings.InventoryCostMethod &&
              CompanySettings.InventoryCostMethod.CodeDescription ===
                "Standard Cost" && (
                <Control>
                  <Label>Standard Cost</Label>
                  <CurrencyInput
                    name="StdCost"
                    value={inputs?.StdCost}
                    onChange={onChange}
                  />
                </Control>
              )}
            {CompanySettings &&
              CompanySettings.InventoryCostMethod &&
              CompanySettings.InventoryCostMethod.CodeDescription ===
                "Average Cost" && (
                <Control>
                  <Label>Average Cost</Label>
                  <CurrencyInput
                    name="AvgCost"
                    value={inputs?.AvgCost}
                    onChange={onChange}
                  />
                </Control>
              )}
            {CompanySettings && CompanySettings.AllowMaintenanceBilling && (
              <Control>
                <Label>List Price</Label>
                <CurrencyInput
                  name="ListPrice"
                  value={inputs?.ListPrice}
                  onChange={onChange}
                />
              </Control>
            )}
            {isAdminOrFinance && (
              <React.Fragment>
                <Control expanded>
                  <GLMainAccountSelect
                    label="Inventory GL Override"
                    name="InvGLRecIdRef"
                    value={inputs?.InvGLRecIdRef}
                    where={{
                      TypeRecIdRef: codeStates.asset.RecId
                    }}
                    onChange={onChange}
                  />
                </Control>
                <Control expanded>
                  <GLMainAccountSelect
                    label="COGS GL Override "
                    name="CogsGLRecIdRef"
                    value={inputs?.CogsGLRecIdRef}
                    where={{
                      TypeRecIdRef: codeStates.expense.RecId
                    }}
                    onChange={onChange}
                  />
                </Control>
              </React.Fragment>
            )}
          </Field>
        </Column>
      </Column.Group>
    </React.Fragment>
  );
};

ItemForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  CompanySettings: PropTypes.object,
  codeStates: PropTypes.object
};

ItemForm.defaultProps = {
  inputs: {}
};
export default ItemForm;
